import { SmallSkeletonListItem } from "../Molecules/skeletons/SmallSkeletonListItem";
import { LargeSkeletonListItem } from "../Molecules/skeletons/LargeSkeletonListItem";

export const CreateTaskViewSkeleton = () => {
  return (
    <>
      <SmallSkeletonListItem />

      <LargeSkeletonListItem />

      {[...Array(3)].map((_, index) => (
        <SmallSkeletonListItem key={index} />
      ))}
    </>
  );
};
